import React from "react";
import styled, { css, keyframes } from "styled-components";

import { ReactComponent as BackSvg } from "../../../svg/close2.svg";
import useSound from "use-sound";
import goBack from "../../../audio/goBack.mp3";
import { logger } from '../../../App'
export const OPBox = styled.div`
  scrollbar-width: none;

  /* padding: 30px; */
  width: 375px;
  height: 667px;
  /* max-width: 315px; */
  max-height: 667px;
  overflow-y: scroll;
  overflow-x: visible;
  position: relative;
  /* height: 607px; */
  /* min-height: 607px; */
  /* width: 375px; */
  padding: 30px;
  overflow-y: scroll;
  /* margin: auto; */
  /* position: relative; */
  /* height: 100%; */
  &&::-webkit-scrollbar {
    display: none;
  }
`;

export const BetreplayDiv = styled.div`
  background-color: #32075b;
  padding: 25px;
  overflow: hidden;
  overflow-y: scroll;
  color: #7f3da5;
  width: 375px;
  overflow-y: scroll;
  height: 667px;

  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
`;
export const Title = styled.div`
  font-size: 20px;
  margin-bottom: 15px;
`;
export const Inner = styled.div`
  margin-bottom: 25px;
  font-size: 20px;
  margin-bottom: 25px;
  overflow-wrap: break-word;
  font-family: "GT America, regular";
`;
export const FinalShuffle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
  > div {
    display: grid;
    grid-template-columns: repeat(5, 56px);
    grid-column-gap: 9px;
    grid-row-gap: 8px;
  }
`;
// export const Ball = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   max-width: 56px;
//   height: 56px;
//   border-radius: 28px;
//   background-color: #7f3da5;
//   color: #32075b;
//   font-size: 20px;
//   font-family: "GT America, bold";
//   font-weight: bold;
//   font-style: normal;
//   font-stretch: expanded;
//   line-height: normal;
//   letter-spacing: normal;
//   text-align: center;
// `;
const btnRotate = keyframes`
  0% {
    transform: rotate(-45deg);
    animation-timing-function: cubic-bezier(0.23, 0.07, 0.08, 0.91);
  }
  33% {
    transform: rotate(13.34deg);
    animation-timing-function: cubic-bezier(0.28, -0.06, 0.61, 0.89);
  }
  66% {
    transform: rotate(-10.65deg);
    animation-timing-function: cubic-bezier(0.32, -0.18, 0.66, 1);
  }
  100% {
    transform: rotate(0deg);
  }
`;
const btnRotateAnim = css`
  ${btnRotate} 500ms forwards
`;
const Back = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  background-color: #ffb000;
  cursor: pointer;
  svg {
    width: 14px;
    animation: ${btnRotateAnim};
  }
`;
const HeaderD = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  height: 40px;

  h1 {
    font-size: 26px;
  }
`;
export const Header = ({ name, handleAbove, sound, volume }) => {
  logger.log({ sound, volume });
  const [goBackSfx] = useSound(goBack, { volume });
  return (
    <HeaderD>
      <h1>{name}</h1>
      <Back
        onClick={() => {
          if (sound) goBackSfx();
          handleAbove(false);
        }}
      >
        <BackSvg />
      </Back>
    </HeaderD>
  );
};

export const Loader = styled.div`
  width: 100%;
  height: calc(100% - 126px);
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 30px;
    color: #ffb000;
    display: flex;
    justify-content: center;
    align-items: baseline;
    text-transform: uppercase;
  }
  span {
    width: 7px;
    height: 7px;
    background: #ffb000;
    border-radius: 50%;
    margin: 0 5px;
    animation: loading 1.5s infinite;
    :nth-child(1) {
      animation-delay: 0s;
    }
    :nth-child(2) {
      animation-delay: 0.25s;
    }
    :nth-child(3) {
      animation-delay: 0.5s;
    }
  }
  @keyframes loading {
    0% {
      transform: scale(1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    50% {
      transform: scale(0.1);
      animation-timing-function: cubic-bezier(0.33, 0, 0, 1);
    }
    100% {
      transform: scale(1);
    }
  }
`;
